/*
 * @Author: Jhonsem
 * @Date: 2018-10-25 20:36:03
 * @Last Modified by: Jhonsem
 * @Last Modified time: 2019-03-05 19:28:47
 */
import * as statusConst from "@/store/constants/status";
import { GetterTree } from "vuex";
import * as types from "@/store/constants/types";
import generalStatusHelper from "@/utils/generalUtils";
import numUtils from "@/utils/numUtils";
import VipOfferUtils from "@/utils/vipOfferUtils";

const Getters: GetterTree<any, any> = {
  [types.GETTER_USER_LIST](state) {
    //因为新增用户是push进去的，所以返回的用户列表需要倒转
    return [...state.userList].reverse();
  },
  [types.GETTER_EARN_COIN_USER_LIST](state) {
    //获取登陆的用户：
    return (type: string = "all") => {
      //初始的列表
      const userList = [...state.userList].reverse().filter((user: any) => {
        return user.userType === "login";
      });
      // restricted 有以下几种：
      // 1.limited 限时并且没有过期
      // 2.login required
      // 3.coding或者warning
      // 4.没有头像或者post
      const restrictedUserList: any = [];
      const bannedUserList: any = []; //被banned的用户的列表
      const workingUserList: any = []; //working

      for (const user of userList) {
        //gx banned:
        if (generalStatusHelper.isBannedUser(user.userId)) {
          bannedUserList.push({
            ...user,
            ...generalStatusHelper.isColdingOrWarningUser(user.userId),
            restrictedType: statusConst.BANNED
          });
          continue;
        }

        //gx warning or colding:
        if (generalStatusHelper.isColdingOrWarningUser(user.userId)) {
          restrictedUserList.push({
            ...user,
            ...generalStatusHelper.isColdingOrWarningUser(user.userId),
            restrictedType:
              generalStatusHelper.isColdingOrWarningUser(user.userId)
                .punish_level === "colding"
                ? statusConst.COLDING
                : statusConst.WARNING
          });
          continue;
        }

        //login required:
        if (generalStatusHelper.isLoginRequiredUser(user.userId)) {
          restrictedUserList.push({
            ...user,
            restrictedType: statusConst.LOGIN_REQUIRED
          });
          continue;
        }

        //completed profile:
        if (user.hasNoProfileMedia || user.hasNoProfilePic) {
          restrictedUserList.push({
            ...user,
            restrictedType: statusConst.COMPLETE_PROFILE
          });
          continue;
        }

        //time limited:
        if (generalStatusHelper.isEarnCoinLimitedUser(user.userId)) {
          restrictedUserList.push({
            ...user,
            ...generalStatusHelper.isEarnCoinLimitedUser(user.userId),
            restrictedType: statusConst.TIME_LIMIT
          });
          continue;
        }

        workingUserList.push(user);
      }

      console.log("GETTER_EARN_COIN_USER_LIST:", {
        userList,
        workingUserList,
        restrictedUserList,
        bannedUserList
      });

      if (type === "all") {
        return userList;
      } else if (type === "working") {
        return workingUserList;
      } else if (type === "restricted") {
        return restrictedUserList;
      } else if (type === "banned") {
        return bannedUserList;
      }
    };
  },
  [types.GETTER_MASTER_ID](state) {
    return state.masterUserId;
  },
  [types.GETTER_CURRENT_INS_POST_ID](state) {
    return state.currentPostId;
  },
  [types.GETTER_CURRENT_INS_VIEW_ID](state) {
    return state.currentViewId;
  },
  [types.GETTER_CURRENT_INS_USER_ID](state) {
    return state.currentUserId;
  },
  [types.GETTER_DEVICE_ID](state) {
    return state.deviceId;
  },
  [types.GETTER_USER_LACK_PROFILE_OR_POST](state) {
    return (userId: any) => {
      const findUser = state.userList.find((user: any) => {
        return userId === user.userId;
      });
      if (findUser) {
        if (findUser.hasNoProfileMedia || findUser.hasNoProfilePic) {
          return findUser;
        } else {
          return false;
        }
      } else {
        return false;
      }
    };
  },
  [types.GETTER_LOGIN_FIRST_USER](state) {
    //返回用户列表中的第一个登陆的用户
    return state.userList.find((user: any) => {
      return user.userType === "login";
    });
  },
  [types.GETTER_INS_LOGIN_USER_ID](state) {
    const insUserInfo =
      state.userList &&
      state.userList.find((user: any) => {
        return user.user_type === "login";
      });
    return insUserInfo && insUserInfo.userId;
  },
  [types.GETTER_INFO_BY_OFFER_DATA](state, getters) {
    return (offer: any, payWay: string = "iap") => {
      try {
        //========================== ins info ========================
        const currentInsUserInfo =
          getters[types.GETTER_CURRENT_INS_USER_INFO] === null
            ? { profile_pic_url: "" }
            : getters[types.GETTER_CURRENT_INS_USER_INFO].insUserInfo;
        //ins meidia info
        let currentInsMediaInfo = null;
        if (offer.kind === "view") {
          currentInsMediaInfo = getters[types.GETTER_CURRENT_INS_MEDIA_INFO](
            "view"
          );
        } else {
          currentInsMediaInfo = getters[types.GETTER_CURRENT_INS_MEDIA_INFO](
            "post"
          );
        }
        const doubleCoinMultiple = Math.floor(
          getters[types.GETTER_DOUBLE_COINS_PERCENTAGE] / 100
        );
        let masterUserPic = currentInsUserInfo
          ? currentInsUserInfo.profile_pic_url
          : "";
        let masterName = currentInsUserInfo ? currentInsUserInfo.username : "";

        // 如果是订阅类型并且是renew，默认购买上一次的
        if (offer.subs_resource) {
          masterUserPic = offer.subs_resource.profile_pic_url;
          masterName = offer.subs_resource.username;
        }

        //=========================== detail info ========================
        let offer_kind: string = offer.kind; //类型
        let unit: string = ""; //订阅的单位
        let unit_price: any = ""; //单位下的价格，用于订阅
        //数量：
        const effect =
          generalStatusHelper.isDoubleCoins() && offer_kind === "coin"
            ? offer.effect * doubleCoinMultiple
            : offer.effect;
        //折扣：
        const discount = offer.discount ? offer.discount : 0; //折扣数
        //经过折扣反算的 原价格(用户外面UI展示):
        let original_price: number =
          offer.iap && offer.iap.hasOwnProperty("price") //原价
            ? Math.floor(
                (parseFloat(offer.iap.price.substring(1)) /
                  (1 - discount / 100)) *
                  100
              ) / 100
            : 0;
        //原价格：（用于payment页面显示原价格）
        const sub_total_price =
          offer.iap && offer.iap.hasOwnProperty("price")
            ? parseFloat(offer.iap.price.substring(1))
            : 0;

        let reward_effect: number = 0;
        let total_price: number = sub_total_price;
        let reduced_price: number = 0;
        let coin_bonus: number = 0; // vip 送金币

        if (offer.pay_data) {
          if (payWay === "iap") {
            total_price = parseFloat(offer.pay_data.iap.price.substring(1));
            reduced_price = sub_total_price - total_price;
            original_price =
              Math.floor((total_price / (1 - discount / 100)) * 100) / 100;

            if (offer.kind.includes("vip")) {
              reward_effect = VipOfferUtils.monthsBonus(offer);
            } else {
              reward_effect =
                (generalStatusHelper.isDoubleCoins() && offer_kind === "coin"
                  ? offer.pay_data.iap.effect * doubleCoinMultiple
                  : offer.pay_data.iap.effect) - effect;
            }
          } else if (payWay === "paypal") {
            total_price = parseFloat(offer.pay_data.paypal.price.substring(1));
            reduced_price = sub_total_price - total_price;
            reward_effect =
              (generalStatusHelper.isDoubleCoins() && offer_kind === "coin"
                ? offer.pay_data.paypal.effect * doubleCoinMultiple
                : offer.pay_data.paypal.effect) - effect;
            original_price =
              Math.floor((total_price / (1 - discount / 100)) * 100) / 100;
          } else if (payWay === "card") {
            total_price = parseFloat(offer.pay_data.stripe.price.substring(1));
            reduced_price = sub_total_price - total_price;
            reward_effect =
              (generalStatusHelper.isDoubleCoins() && offer_kind === "coin"
                ? offer.pay_data.stripe.effect * doubleCoinMultiple
                : offer.pay_data.stripe.effect) - effect;
            original_price =
              Math.floor((total_price / (1 - discount / 100)) * 100) / 100;
          } else if (payWay === "super_pay") {
            total_price = parseFloat(
              offer.pay_data.super_pay.price.substring(1)
            );
            reduced_price = sub_total_price - total_price;
            reward_effect =
              (generalStatusHelper.isDoubleCoins() && offer_kind === "coin"
                ? offer.pay_data.super_pay.effect * doubleCoinMultiple
                : offer.pay_data.super_pay.effect) - effect;
            original_price =
              Math.floor((total_price / (1 - discount / 100)) * 100) / 100;
          }
          if (offer.kind.includes("vip")) {
            coin_bonus = VipOfferUtils.coinsBonus(offer);
          }
        }

        // 1. super_vip,xx_vip 过滤为vip 2.xxx_subs_follow过滤过subs_follow,subs_like
        if (offer_kind.indexOf("vip") > -1) {
          offer_kind = "vip";
        } else if (offer_kind.indexOf("subs_follow") > -1) {
          offer_kind = "subs_follow";
        } else if (offer_kind.indexOf("subs_like") > -1) {
          offer_kind = "subs_like";
        }

        let result: any = {
          offer,
          effect,
          unit, //订阅的单位
          unit_price, //每个月的价格
          reward_effect, //奖励的多少
          discount, //打折的多少
          original_price, //原价多少
          total_price, //现价多少
          sub_total_price,
          userName: currentInsUserInfo ? currentInsUserInfo.username : "",
          coin_bonus
        };

        if (reduced_price > 0) {
          result.reduced_price = reduced_price; //减去了多少价格
        }

        //如果是订阅类型的话，需要给出他的单位 :period
        if (generalStatusHelper.isSubsOffer(offer)) {
          const { subscription } = offer;
          //首字母大写：
          unit =
            subscription.period_type.substring(0, 1).toUpperCase() +
            subscription.period_type.substring(1);
          //添加末尾的s
          if (subscription.period > 1) {
            unit = unit + "s";
          }
          unit_price = (total_price / effect).toFixed(2);
          result = {
            ...result,
            unit,
            unit_price
          };
        }

        switch (offer_kind) {
          case "follow": {
            return {
              ...result,
              pic_url: currentInsUserInfo.profile_pic_url,
              pic_type: "circle",
              type_name: "Followers",
              type_icon: require("@/assets/icons-file/sku/icon_followers.png")
            };
          }
          case "special_follow": {
            return {
              ...result,
              pic_url: currentInsUserInfo.profile_pic_url,
              pic_type: "circle",
              type_name: "Followers",
              type_icon: require("@/assets/icons-file/sku/icon_followers.png")
            };
          }
          case "golden_follow": {
            return {
              ...result,
              pic_url: currentInsUserInfo.profile_pic_url,
              pic_type: "circle",
              type_name: "Golden Followers",
              type_icon: require("@/assets/icons-file/sku/icon_golden_followers.png")
            };
          }
          case "like": {
            return {
              ...result,
              pic_url: generalStatusHelper.getInsPostData(currentInsMediaInfo)
                .pic_url,
              pic_type: "cube",
              type_name: "Likes",
              type_icon: require("@/assets/icons-file/sku/icon_likes.png")
            };
          }
          case "special_like": {
            return {
              ...result,
              pic_url: generalStatusHelper.getInsPostData(currentInsMediaInfo)
                .pic_url,
              pic_type: "cube",
              type_name: "Likes",
              type_icon: require("@/assets/icons-file/sku/icon_likes.png")
            };
          }
          case "view": {
            return {
              ...result,
              pic_url: generalStatusHelper.getInsPostData(currentInsMediaInfo)
                .pic_url,
              pic_type: "cube",
              type_name: "Views",
              type_icon: require("@/assets/icons-file/sku/icon_views.png")
            };
          }
          case "comment": {
            return {
              ...result,
              pic_url: generalStatusHelper.getInsPostData(currentInsMediaInfo)
                .pic_url,
              pic_type: "cube",
              type_name: "Comments",
              type_icon: require("@/assets/icons-file/sku/icon_comments.png")
            };
          }
          case "coin": {
            return {
              ...result,
              pic_url: masterUserPic,
              userName: masterName,
              pic_type: "circle",
              type_name: "Coins",
              type_icon: require("@/assets/icons-file/sku/coins.png")
            };
          }
          case "feed_coin": {
            return {
              ...result,
              pic_url: masterUserPic,
              userName: masterName,
              pic_type: "circle",
              type_name: "Coins",
              type_icon: require("@/assets/icons-file/sku/coins.png")
            };
          }
          case "half_coin": {
            return {
              ...result,
              pic_url: masterUserPic,
              userName: masterName,
              pic_type: "circle",
              type_name: "Coins",
              type_icon: require("@/assets/icons-file/sku/coins.png")
            };
          }
          case "lucky_coin": {
            const { lucky_effect } = offer;
            // const maxNum = ;
            lucky_effect && lucky_effect.min
              ? (result.effect =
                  lucky_effect.min +
                  "~" +
                  numUtils.toThousands(lucky_effect.max))
              : void 0;
            return {
              ...result,
              pic_url: masterUserPic,
              userName: masterName,
              pic_type: "circle",
              type_name: "Lucky Coins",
              type_icon: require("@/assets/icons-file/sku/coins.png")
            };
          }
          case "special_coin": {
            return {
              ...result,
              pic_url: masterUserPic,
              userName: masterName,
              pic_type: "circle",
              type_name: "Coins",
              type_icon: require("@/assets/icons-file/sku/coins.png")
            };
          }
          case "limited_coin": {
            return {
              ...result,
              pic_url: masterUserPic,
              userName: masterName,
              pic_type: "circle",
              type_name: "Coins",
              type_icon: require("@/assets/icons-file/sku/coins.png")
            };
          }
          case "vip": {
            //Vip固定的单位是Month:
            return {
              ...result,
              pic_url: masterUserPic,
              userName: masterName,
              pic_type: "circle",
              type_name: "VIP",
              type_icon: require("@/assets/icons-file/payment/vip.png"),
              unit: offer.effect > 1 ? "Months" : "Month"
            };
          }
          case "subs_like": {
            return {
              ...result,
              pic_url: masterUserPic,
              userName: masterName,
              pic_type: "circle",
              type_name: "SubsLike",
              type_icon: require("@/assets/icons-file/sku/icon_likes.png"),
              special_unit: "/post",
              period: "1 week"
            };
          }
          case "subs_follow": {
            return {
              ...result,
              pic_url: masterUserPic,
              userName: masterName,
              pic_type: "circle",
              type_name: "SubsFollower",
              type_icon: require("@/assets/icons-file/sku/icon_followers.png"),
              special_unit: "/day",
              period: "1 week"
            };
          }
          default:
            break;
        }
      } catch (error) {
        console.log("Getters indexgeetr:", {
          error,
          offer,
          payWay
        });
      }
    };
  },
  [types.GETTER_TYPE_OF_SUBS](state, getters) {
    return (offer: any) => {
      return offer.kind.indexOf("subs") > -1 || offer.kind.indexOf("vip") > -1;
    };
  },
  [types.GETTER_CAN_SHOW_VIP_NAV](state, getter) {
    return (offer: any) => {
      return (
        !generalStatusHelper.isVip() &&
        !getter[types.GETTER_TYPE_OF_SUBS](offer) &&
        offer.kind.indexOf("coin") === -1
      );
    };
  }
};

export default Getters;
